import classNames from "classnames";
import { useButtonEventTracking } from "@hooks/use-button-event-tracking";
import CustomLoader from "../CustomLoader";

function MenuListButton({
  trackingName = "",
  onClick = () => {},
  title,
  children,
  className,
  loading,
  ...props
}) {
  const trackEvent = useButtonEventTracking();

  function handleClick(event) {
    const buttonName = title || children;

    trackEvent(trackingName, buttonName);
    onClick(event);
  }

  return (
    <button
      {...props}
      title={title || children}
      className={classNames("menu-list-button", className)}
      onClick={handleClick}
    >
      {loading ? (
        <span className="menu-list-button-loader-container">
          <CustomLoader
            className="ms-2"
            variant="SpinnerMiddleGray"
            style={{ width: "24px" }}
          />
        </span>
      ) : (
        <span className="menu-list-button-children-container">{children}</span>
      )}
    </button>
  );
}

export default MenuListButton;
